import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabasePublishableKey) {
  throw new Error('Missing Supabase environment variables. Set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY in .env.');
}

if (import.meta.env.DEV) {
  console.info('[Supabase Client] env loaded', {
    supabaseUrl,
    hasPublishableKey: Boolean(supabasePublishableKey)
  });
}

const supabaseFetch: typeof fetch = async (input, init) => {
  try {
    const response = await fetch(input, init);

    if (import.meta.env.DEV) {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
      console.info('[Supabase Fetch]', {
        url,
        method: init?.method ?? 'GET',
        status: response.status,
        ok: response.ok
      });
    }

    return response;
  } catch (error) {
    if (import.meta.env.DEV) {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
      console.error('[Supabase Fetch Error]', {
        url,
        method: init?.method ?? 'GET',
        error: error instanceof Error
          ? {
              name: error.name,
              message: error.message
            }
          : error
      });
    }

    throw error;
  }
};

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  global: {
    fetch: supabaseFetch
  }
});
